import { getFilenameFromUrl } from './download-utils';

/**
 * Downloads a file by fetching it as a blob first (bypasses cross-origin download restrictions).
 * For cross-origin URLs (e.g. S3), the browser ignores the `download` attribute and opens files
 * in a new tab instead. Fetching as blob creates a same-origin blob URL that respects `download`.
 */
const download = async (url: string, filename?: string): Promise<void> => {
  try {
    const response = await fetch(url, { mode: 'cors' });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const anchor = document.createElement('a');
    anchor.style.display = 'none';
    anchor.href = blobUrl;
    anchor.download = filename || getFilenameFromUrl(url, `download-${Date.now()}`);

    document.body.appendChild(anchor);
    anchor.click();

    // Delay cleanup — browser reads blob URL asynchronously
    setTimeout(() => {
      anchor.remove();
      URL.revokeObjectURL(blobUrl);
    }, 60000);
  } catch (error) {
    console.error(`Failed to download file (${filename || url}):`, error);
    throw error;
  }
};

export { download };
